import {
  RESET_HYP_YAML_IMPORT,
  SET_IS_FIRST_TIME_YAML_IMPORT,
  SET_SELECTED_YAML_FILE,
  SET_YAML_FILE_LIST,
  SHOW_YAML_IMPORT,
} from '@/actions/hypYamlImport';
import { Action } from 'redux';
import cloneDeep from 'lodash/cloneDeep';

const initialState = {
  showYamlImport: false,
  isFirstTime: false,
  yamlFileList: [],
  selectedYamlFile: '',
};

export default function hypYamlImport(
  state = initialState,
  action: Action<string>
) {
  const { type, payload = {} }: any = action;
  switch (type) {
    case SHOW_YAML_IMPORT:
      return {
        ...state,
        showYamlImport: payload,
      };
    case SET_YAML_FILE_LIST:
      return {
        ...state,
        yamlFileList: payload,
      };
    case SET_SELECTED_YAML_FILE:
      return {
        ...state,
        selectedYamlFile: payload,
      };
    case SET_IS_FIRST_TIME_YAML_IMPORT:
      return {
        ...state,
        isFirstTime: payload,
      };
    case RESET_HYP_YAML_IMPORT:
      return cloneDeep(initialState);
    default:
      return state;
  }
}
